export * from "./dataSourceReducer";
export * from "./appointmentReducer";
export * from "./bookingReducer";
export * from "./configReducer";
export * from "./waitingListReducer";



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/reducers/index.js